<template>
    <div>
        <div class="nav-container-s">
            <div class="nav">
                <div class="box-row-f">
                    <div v-for="(item, index) in 10" :key="item" class="box1-wrapper3" @click="goToDetail">
                        <div class="box-left">
                            <img src="../assets/images/tiku-img.png" alt="">
                        </div>
                        <div class="box-right">
                            <div class="box-text-top">
                                This is the titleofthequestionbank
                                <br />
                                This is the title of the
                            </div>
                            <div class="box-text-bottom">
                                <text>
                                    Viewdetails
                                </text>
                                <img src="../assets/images/Vector.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="logo-a-g">
                    <Arrowhead />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Arrowhead from '../components/Arrowhead.vue'
const router = useRouter();
function goToDetail() {
    router.push({ path: "/Detail-pdf" });
}
</script>

<style scoped>
@import '../pages/index-m.css'

/* @import '../pages/index-c.css' */
</style>